import StaffBioModal from "../../../../../_components/StaffBioModal";
import StaffMember from "../../../../../types/StaffMember";
import {INSTRUCTOR_TBD_NAME_FLAG} from "../tbdInstructorNameFlag";

interface AvailableSessionsInstructorProps {
	instructor: StaffMember | null;
	fallbackTeacher?: string | null;
}

const AvailableSessionsInstructor: React.FC<
	AvailableSessionsInstructorProps
> = ({instructor, fallbackTeacher}) => {
	if (!instructor) {
		if (!fallbackTeacher || fallbackTeacher === INSTRUCTOR_TBD_NAME_FLAG) {
			return <span>Instructor: TBD</span>;
		}
		return (
			<span>
				Instructor: <a className="pt-0.5">{fallbackTeacher}</a>
			</span>
		);
	}
	return (
		<span>
			Instructor:{" "}
			<StaffBioModal staffMember={instructor}>
				<a className="cursor-pointer pt-0.5 underline decoration-muted-midtone-orange underline-offset-4 hover:bg-pale-peach">
					{instructor?.name}
				</a>
			</StaffBioModal>
		</span>
	);
};

export default AvailableSessionsInstructor;
